export const CONFIG = {
  API_URL: validate(import.meta.env.VITE_API_URL, "API_URL"),
  CDN_URL: validate(import.meta.env.VITE_CDN_URL, "CDN_URL"),
  AUTH_URL: validate(import.meta.env.VITE_AUTH_URL, "AUTH_URL"),
  AUTH_REALM: validate(import.meta.env.VITE_AUTH_REALM, "AUTH_REALM"),
  AUTH_CLIENT_ID: validate(import.meta.env.VITE_AUTH_CLIENT_ID, "AUTH_CLIENT_ID"),
  AUTH_PASSWORD_RESET: validate(import.meta.env.VITE_AUTH_PASSWORD_RESET, "AUTH_PASSWORD_RESET"),
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  DOCS_URL: validate(import.meta.env.VITE_DOCS_URL ?? "https://docs.dev.finbricks.com/", "DOCS_URL"),
  TUTORIAL_URL: "/tutorial/index.html",
};

function validate(value: unknown, name: string): string {
  const isValid = typeof value === "string" && value.length;

  if (!isValid) throw new Error(`ENV variable ${name} must be defined.`);

  return value;
}
